import React from "react";
import "./HeroSection.css";
// import { Button } from "./Button";

function HeroSection() {
  return (
    <div className="hero-container">
      <img
        className="background-image"
        src="/images/Site background pic.jpg"
        alt="background"
      />
      <br></br>
      <h1>Taking comedy shows to a whole new level!</h1>
      <h2>
        Creating and promoting the best and brightest sketch, improv, and
        variety shows in Chicago.
      </h2>

      <button type="button" class="btn btn-outline-dark btn-rounded">
        <a href="/productions">Current Productions</a>
      </button>
    </div>
  );
}

export default HeroSection;
